import '../angular/services/agent-inventory-dialog.service';
import './agent-inventory-api.factory';
import '../$agent-inventory.factory';
import './agent-inventory-requests.service';
import './agent-inventory-service.service';

